var _defs, _polygon, _rect, _rect2, _text, _line, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgL4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 950 260",
    width: 950,
    height: 260,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400&amp;family=Noto+Naskh+Arabic:wght@500&amp;display=swap');\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5a4b38",
    points: "       130,70       154,94   166,94                166,106       190,130                166,154       166,166       154,166       130,190       106,166  94,166                94,154       70,130                94,106       94,94       106,94     "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 106,
    width: 48,
    height: 48,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 111,
    width: 38,
    height: 38,
    fill: "none",
    stroke: "white",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 136,
    textAnchor: "middle",
    fill: "white",
    fontSize: 17,
    fontFamily: "'Noto Naskh Arabic', 'Traditional Arabic', 'Arabic Typesetting', serif",
    direction: "rtl",
    unicodeBidi: "embed"
  }, "\u0634\u064A\u0631\u064A\u0646")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 216,
    y1: 80,
    x2: 216,
    y2: 180,
    stroke: "#5a4b38",
    strokeWidth: 1.4
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 235,
    y: 152,
    fill: "#5a4b38",
    fontFamily: "'Cormorant Garamond', 'EB Garamond', Garamond, 'Times New Roman', serif",
    fontSize: 66,
    fontWeight: 400,
    fontStyle: "normal",
    letterSpacing: 1.5
  }, "Shereen Investment")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL4);
export default __webpack_public_path__ + "static/media/l4.59e289cface8ea8e7abf9d1e87f30ecb.svg";
export { ForwardRef as ReactComponent };